import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ACCOUNTING_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { SubscriptionAccountingTab } from "../components/SubscriptionAccountingTab"

const useStyles = makeStyles()(() => ({
    content: {
        width: "100%",
    },
}))

export function Subscriptions() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="accounting-subscriptions-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.ACCOUNTING_SUBSCRIPTIONS}
                    title="Subscriptions"
                    icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ACCOUNTING_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-nav-item-accounting">
                            <Breadcrumb>Accounting</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="accounting-subscriptions-breadcrumb-title">
                            <Breadcrumb>Subscriptions</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box className={classes.content}>
                <SubscriptionAccountingTab />
            </Box>
        </>
    )
}
